import React, { useMemo } from 'react';
import { Link } from 'react-router';
import { useAuth } from '../../../utils/Auth';
import styles from './MarketingButtons.module.css';

// Main marketing button component
export default function MarketingButtons() {
    const { userObj } = useAuth();

    const handleDynamicReturn = useMemo(() => {
        const { account_type, enterprise } = userObj;
    
        if (enterprise) {
            return <div className={styles.btn}>Enterprise Account</div>;
        } else {
            switch(account_type) {
                case 'pro':
                    return <div className={styles.btn}>Pro Account</div>;
                case 'basic':
                default:
                    return <Link className={`${styles.btn} ${styles.link}`} to='/upgrade'>Upgrade to Pro</Link>;
            }
        }
    
    },[userObj]);

    return (
        <div className={styles.container}>
            {handleDynamicReturn}
            <a href='https://nineeagles.com/' className={`${styles.btn} ${styles.link}`} target='_blank'>Shop Merch</a>
        </div>
    );
};